import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2ApprovalResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function lockIndirectTaxFilingV2({
  filingId,
  corporationId,
  token,
}: {
  filingId: string;
  corporationId: number;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2ApprovalResponse>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}/lock?corporationId=${corporationId}`,
      { method: 'POST' },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to lock filing',
      };
    }
    const data: IIndirectTaxFilingV2ApprovalResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to lock filing',
    };
  }
}
